import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component,
         EventEmitter, Input, Output } from '@angular/core';

import { FontInjectorService } from 'collage-designer/font-injector.service';
import { FontStoreService } from 'core/fontstore/fontstore.service';

export interface FontGroup {
  name: string;
  label: string;
  fonts: Array<string>;
}

@Component({
    selector: 'font-chooser',
    templateUrl: './font-chooser.component.html',
    styleUrls: ['./font-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FontChooserComponent implements AfterViewInit
{
  @Input() public fontName: string = '';
  @Output() public fontNameChange: EventEmitter<string> = new EventEmitter();

  public fontGroups: Array<FontGroup> = [
    {
      name: 'modern',
      label: 'i18n.control.fontChooser.group.modern',
      fonts: []
    },
    {
      name: 'classic',
      label: 'i18n.control.fontChooser.group.classic',
      fonts: []
    },
    {
      name: 'handwritten',
      label: 'i18n.control.fontChooser.group.handwritten',
      fonts: []
    },
    {
      name: 'creative',
      label: 'i18n.control.fontChooser.group.creative',
      fonts: []
    },
    {
      name: 'technical',
      label: 'i18n.control.fontChooser.group.technical',
      fonts: []
    },
  ];

  constructor(
    private fontStoreService: FontStoreService,
    private fontInjectorService: FontInjectorService,
    private changeDetectorRef: ChangeDetectorRef,
  )
  {}

  public ngAfterViewInit(): void
  {
    this.updateAvailableFonts();
  }

  private async updateAvailableFonts(): Promise<void>
  {
    for (const font of (await this.fontInjectorService.getFonts())) {
      const groups = this.fontGroups.filter(g => g.name === font.group);
      if (groups.length > 0 && groups[0].fonts.indexOf(font.name) === -1) {
        groups[0].fonts.push(font.name);
      }
    }
    this.changeDetectorRef.markForCheck();
  }

  public setFontName(value: string): void
  {
    this.fontNameChange.emit(value);
  }

  public getFontPreviewUrl(fontName: string): string
  {
    return this.fontStoreService.getFontPreviewUrl(fontName);
  }
}
